import { useTranslation } from '@/shared/hooks/useTranslation'
import { ResourceActiveFilterChips } from '@/shared/ui/Layout'

import { getProgrammingKind } from '../model/kind'
import type { AdvancedFilters } from '../model/types'

type ScheduleActiveFiltersProps = {
  filters: AdvancedFilters
  speakerName?: string | null
  onRemovePlace: () => void
  onRemoveSpeaker: () => void
  onRemoveKind: () => void
}

export const ScheduleActiveFilters = ({
  filters,
  speakerName,
  onRemovePlace,
  onRemoveSpeaker,
  onRemoveKind
}: ScheduleActiveFiltersProps) => {
  const { t } = useTranslation()

  const chips = [
    filters.place && {
      id: 'place',
      label: `${t('schedule.advancedFilters.place')}: ${filters.place}`
    },
    filters.speaker &&
      speakerName && {
        id: 'speaker',
        label: `${t('schedule.advancedFilters.speaker')}: ${speakerName}`
      },
    filters.kind && {
      id: 'kind',
      label: `${t('schedule.advancedFilters.kind')}: ${t(getProgrammingKind(filters.kind).nameKey)}`
    }
  ].filter(Boolean) as { id: string; label: string }[]

  return (
    <ResourceActiveFilterChips
      chips={chips}
      onRemove={id => {
        if (id === 'place') onRemovePlace()
        if (id === 'speaker') onRemoveSpeaker()
        if (id === 'kind') onRemoveKind()
      }}
    />
  )
}
